/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Component, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { AbstractControl, ControlContainer } from '@angular/forms';
import { SubSink } from 'subsink';

@Component({
  selector: 'payment-auth-verbiage',
  templateUrl: './auth-verbiage.component.html',
  styleUrls: ['./auth-verbiage.component.scss'],
})
export class AuthVerbiageComponent implements OnInit {
  @Input()
  authVerbiageText: string;

  @Input()
  controlName: string;

  icon = '';

  get severity(): 'info' | 'success' | 'error' {
    return this.getSeverity();
  }

  private control: AbstractControl;
  private subSink = new SubSink();

  private get authorizeChecked(): boolean {
    return this.control.value;
  }

  constructor(
    @Optional()
    @SkipSelf()
    private controlContainer: ControlContainer,
  ) {}

  ngOnInit(): void {
    if (this.controlContainer != null) {
      this.initializeFormControl();
    }

    this.updateIcon();
  }

  onAuthorizeChecked() {
    if (this.control == null) {
      return;
    }

    this.control.markAsTouched();
    this.control.setValue(!this.control.value);
  }

  private initializeFormControl() {
    if (this.controlName == null) {
      return;
    }

    this.control = this.controlContainer.control.get(this.controlName);

    this.subSink.add(
      this.control.valueChanges.subscribe(() => {
        this.getSeverity();
        this.updateIcon();
      }),
    );
  }

  private getSeverity() {
    if (this.control == null) {
      return 'info';
    }

    if (this.authorizeChecked) {
      return 'success';
    }

    return this.control.touched ? 'error' : 'info';
  }

  private updateIcon() {
    if (this.control == null) {
      return;
    }

    this.icon = this.control.value ? 'check_box' : 'check_box_outline_blank';
  }
}
